import * as z from 'zod';
import { finalContractSuretyBondFormTypeSchema, suretyTypeSchema } from '../../../enums.mjs';
import { parentNaicsCodesExtractionValue } from '../../naics-codes/naics-codes.mjs';
import { extractionFieldSchema, nullableBooleanExtractionFieldSchema, numberExtractionFieldSchema, stringExtractionFieldSchema, percentExtractionFieldSchema } from '../extraction-field.mjs';

const NOT_DETERMINED_EXPLANATION_PREFIX = "Not determined —";
const ScopeOfWorkField = extractionFieldSchema(parentNaicsCodesExtractionValue(2));
const bondRequestDocumentTypeDef = [
    "contract",
    "rfp",
    "bond_request_form",
    "submission_narrative",
    "email_thread",
    "other",
];
const bondRequestDocumentTypeSchema = z.enum(bondRequestDocumentTypeDef);
const DocumentTypeField = extractionFieldSchema(bondRequestDocumentTypeSchema);
const bondAmountTypeDef = ["percent", "dollars"];
const bondAmountTypeSchema = z.enum(bondAmountTypeDef);
const BondAmountTypeField = extractionFieldSchema(bondAmountTypeSchema.nullish());
const FinalBondFormTypeField = extractionFieldSchema(finalContractSuretyBondFormTypeSchema.nullish());
const BondRequestExtractionOutputFull = z.object({
    projectDescription: stringExtractionFieldSchema,
    projectName: stringExtractionFieldSchema,
    projectNumber: stringExtractionFieldSchema,
    scopeOfWork: ScopeOfWorkField,
    projectCity: stringExtractionFieldSchema,
    projectState: stringExtractionFieldSchema,
    contractOrBidAmount: numberExtractionFieldSchema,
    bondAmount: numberExtractionFieldSchema,
    bondAmountAsPercentOfBid: percentExtractionFieldSchema,
    bondAmountType: BondAmountTypeField,
    bidDate: stringExtractionFieldSchema,
    contractDate: stringExtractionFieldSchema,
    finalBondFormType: FinalBondFormTypeField,
    timeToCompleteMonths: numberExtractionFieldSchema,
    warrantyPeriodMonths: numberExtractionFieldSchema,
    consequentialDamages: nullableBooleanExtractionFieldSchema,
    primeContractDamages: nullableBooleanExtractionFieldSchema,
    liquidatedOver5k: nullableBooleanExtractionFieldSchema,
    otherDamages: nullableBooleanExtractionFieldSchema,
    designBuild: nullableBooleanExtractionFieldSchema,
    environmentalRemediation: nullableBooleanExtractionFieldSchema,
    superfundSite: nullableBooleanExtractionFieldSchema,
    efficiencyGuarantees: nullableBooleanExtractionFieldSchema,
    sovereignNation: nullableBooleanExtractionFieldSchema,
    renewableContract: nullableBooleanExtractionFieldSchema,
    takeover: nullableBooleanExtractionFieldSchema,
    completionBond: nullableBooleanExtractionFieldSchema,
    tListingRequired: nullableBooleanExtractionFieldSchema,
});
const emailSubmissionIntentDef = [
    "account_submission",
    "account_submission_with_bond_request",
    "bond_request",
];
const emailSubmissionIntentSchema = z.enum(emailSubmissionIntentDef);
const EmailSubmissionIntentField = extractionFieldSchema(emailSubmissionIntentSchema.nullish());
const SuretyTypeField = extractionFieldSchema(suretyTypeSchema.nullish());
const BondRequestExtractionOutputEmailFull = BondRequestExtractionOutputFull.extend({
    accountName: stringExtractionFieldSchema,
    submissionIntent: EmailSubmissionIntentField,
    suretyType: SuretyTypeField,
});
const BondRequestExtractionOutputMinimal = BondRequestExtractionOutputFull.pick({
    projectName: true,
    contractOrBidAmount: true,
    bondAmount: true,
    bondAmountAsPercentOfBid: true,
    bondAmountType: true,
});
const BondRequestExtractionOutput = BondRequestExtractionOutputFull.partial();

export { BondRequestExtractionOutput, BondRequestExtractionOutputEmailFull, BondRequestExtractionOutputFull, BondRequestExtractionOutputMinimal, DocumentTypeField, NOT_DETERMINED_EXPLANATION_PREFIX, bondAmountTypeDef, bondAmountTypeSchema, bondRequestDocumentTypeDef, bondRequestDocumentTypeSchema, emailSubmissionIntentDef, emailSubmissionIntentSchema };
